<template>
<div
    v-on:focusout="onFocusOut"
>
    <div
        v-if="parsed_value == null && is_default"
    >
        <div
            style="display: flex; gap: 15px;"
        >
            <div
                style="flex-grow: 1"
            >
                <div 
                    style="font-size: 18px; margin-bottom: 7px;">
                    <b>{{label}}</b>
                </div>

                <v-text-field
                    label="CSS"
                    value="No Default Value"
                    :readonly="is_default"
                    disabled
                />
            </div>
        </div>
    </div>

    <div
        v-if="parsed_value != null"
    >
        <div
            style="display: flex; gap: 15px;"
        >
            <div
                v-if="parsed_value.type == 'unknown'"
                style="flex-grow: 1"
            >
                <div 
                    style="font-size: 18px; margin-bottom: 7px;">
                    <b>{{label}}</b>
                </div>

                <v-text-field
                    label="CSS"
                    v-model="css"
                    :readonly="is_default"
                    :disabled="is_default"
                    v-on:input="onEdit"
                />
            </div>

            <div
                v-if="parsed_value.type == 'rgba'"
                style="flex-grow: 0px; min-width: 150px; height: 150px; position: relative; border: 1px solid rgba(0,0,0,0.3); justify-content: center;"
            >
                <div
                    class="checker"
                />

                <div
                    class="swatch"
                    :style="style_color_swatch"
                />
            </div>

            <div
                style="flex-grow: 1"
                v-if="parsed_value.type == 'rgba'"
            >
                <div 
                    style="font-size: 18px; margin-bottom: 7px;">
                    <b>{{label}}</b>
                </div>

                <div
                    style="display: flex; gap: 10px;"
                >
                    <v-text-field
                        label="Red"
                        v-model="parsed_value.red"
                        :readonly="is_default"
                        :disabled="is_default"
                        v-on:input="onEdit"
                    />

                    <v-text-field
                        label="Green"
                        v-model="parsed_value.green"
                        :readonly="is_default"
                        :disabled="is_default"
                        v-on:input="onEdit"
                    />

                    <v-text-field
                        label="Blue"
                        v-model="parsed_value.blue"
                        :readonly="is_default"
                        :disabled="is_default"
                        v-on:input="onEdit"
                    />

                    <v-text-field
                        label="Alpha"
                        v-model="parsed_value.alpha"
                        :readonly="is_default"
                        :disabled="is_default"
                        v-on:input="onEdit"
                    >

                    </v-text-field>
                </div>

                <v-text-field
                    label="CSS"
                    :value="css"
                    :readonly="true"
                    :disabled="true"
                />



            </div>

            <div
                v-if="parsed_value.type == 'dimensioned-value'"
                style="flex-grow: 1"
            >
                <div 
                    style="font-size: 18px; margin-bottom: 7px;">
                    <b>{{label}}</b>
                </div>

                <div
                    style="display: flex; gap: 10px;"
                >
                    <v-text-field
                        label="Magnitude"
                        v-model="parsed_value.magnitude"
                        :readonly="is_default"
                        :disabled="is_default"
                        v-on:input="onEdit"
                    />

                    <v-text-field
                        label="Unit"
                        v-model="parsed_value.unit"
                        :readonly="true"
                        :disabled="true"
                    />
                </div>

                <v-text-field
                    label="CSS"
                    :value="css"
                    :readonly="true"
                    :disabled="true"
                />
            </div>

            <div
                v-if="parsed_value.type == 'directional'"
                style="flex-grow: 1"
            >
                <div 
                    style="font-size: 18px; margin-bottom: 7px;">
                    <b>{{label}}</b>
                </div>

                <div
                    style="display: flex; gap: 30px;"
                >
                    <v-text-field
                        label="top"
                        v-model="parsed_value.top.magnitude"
                        :readonly="is_default"
                        :disabled="is_default"
                        v-on:input="onEdit"
                    >
                        <template #append>
                            {{parsed_value.top.unit}}
                        </template> 
                    </v-text-field>

                    <v-text-field
                        label="right"
                        v-model="parsed_value.right.magnitude"
                        :readonly="is_default"
                        :disabled="is_default"
                        v-on:input="onEdit"
                    >
                        <template #append>
                            {{parsed_value.right.unit}}
                        </template> 
                    </v-text-field>

                    <v-text-field
                        label="bottom"
                        v-model="parsed_value.bottom.magnitude"
                        :readonly="is_default"
                        :disabled="is_default"
                        v-on:input="onEdit"
                    >
                        <template #append>
                            {{parsed_value.bottom.unit}}
                        </template> 
                    </v-text-field>

                     <v-text-field
                        label="left"
                        v-model="parsed_value.left.magnitude"
                        :readonly="is_default"
                        :disabled="is_default"
                        v-on:input="onEdit"
                    >
                        <template #append>
                            {{parsed_value.left.unit}}
                        </template> 
                    </v-text-field>
                    
                </div>

                <v-text-field
                    label="CSS"
                    :value="css"
                    :readonly="true"
                    :disabled="true"
                />
            </div>

            <div
                v-if="parsed_value.type == 'font-stack'"
                style="flex-grow: 1"
            >
                <v-select
                    label="Font"
                    :items="organized_font_families"
                    v-model="css"
                    :readonly="is_default"
                    :disabled="is_default"
                    v-on:change="onEdit"
                    item-text="text"
                    item-value="value"
                    :filter="fontSearchFilter"
                >
                    <template v-slot:item="{ item }">
                        <div v-if="item.header" class="font-section-header">
                            {{ item.header }}
                        </div>
                        <div v-else class="font-item">
                            <span :style="'font-family: ' + item.value" class="font-preview">
                                {{ item.text }}
                            </span>
                        </div>
                    </template>
                </v-select>

                <div
                    :style="style_demo_font"
                    class="font-demo"
                >
                    {{ truncated_preview_text }}
                </div>
            </div>
            

        </div>
    </div>

    <!-- Color Picker Dialog -->
    <v-dialog
        v-model="color_picker_dialog"
        max-width="400"
        :attach="false"
        :z-index="9999"
    >
        <v-card>
            <v-card-title>Color Picker</v-card-title>
            <v-card-text>
                <v-color-picker
                    v-model="color_picker_value"
                    mode="rgba"
                    show-swatches
                    dot-size="25"
                    canvas-height="150"
                    swatches-max-height="200"
                />
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    text
                    @click="color_picker_dialog = false"
                >
                    Cancel
                </v-btn>
                <v-btn
                    color="primary"
                    text
                    @click="onColorPickerOk"
                >
                    OK
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
const _ = require('lodash');

export default {
    props: {
        value: {
            type: String,
            default: function() { return null; }
        },

        is_default: {
            type: Boolean,
            default: function() { return false; }
        },

        property_name: {
            type: String,
            default: function() { return null; }
        },

        preview_text: {
            type: String,
            default: function() { return 'Lorem ipsum'; }
        },
    },

    data() {
        return {
            css: null,
            parsed_value: null,
            font_families: [],
            custom_fonts: [],
            color_picker_dialog: false,
            color_picker_value: { r: 255, g: 0, b: 0, a: 1 },
        }
    },

    created() {
        this.update();
    },

    methods: {
        update() {

            if ( this.value == null )
            {
                this.parsed_value = null;
                return;
            }

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/css/parse',
            
                'params' : {
                        'css': this.value,
                        'property_name': this.property_name,
                    },
            
                'on_success': (data) => {
                        this.css = data.css;
                        this.parsed_value = data.parsed_value;

                        if ( this.parsed_value.type == 'font-stack' )
                            this.updateFontFamilies();
                    },
            
                'on_error': () => { this.parse = null; },
            });
        },

        updateFontFamilies()
        {
            if ( this.font_families.length > 0 )
                return;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/css/available-font-families',

                'params' : {
                        'organization_id': this.$route.params.organization_id,
                    },

                'on_success': (data) => {
                        this.font_families = data.choices;
                        this.custom_fonts = data.custom_fonts || [];
                    },

                'on_error': 'Unable to list font families',
            });
        },

        onFocusOut()
        {
            if ( !this.is_default )
                this.doEdit();
        },

        onEdit: _.debounce(function(){
            this.doEdit();
        }, 751),
        
        doEdit()
        {
            if ( this.parsed_value.type == 'font-stack' )
            {
                // Direct edit css types
                this.$emit('input',this.css);
                return;
            }

            if ( this.parsed_value.type == 'unknown' )
            {
                this.$emit('input', this.css);
                return;
            }

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/css/compute',
            
                'params' : {
                        'parsed_value': this.parsed_value,
                    },
            
                'on_success': (data) => {
                        this.parsed_value = data.parsed_value;
                        this.css = data.css;
                        this.$emit('input',data.css);
                    },
            
                'on_error': () => {},
            });
        },
        

        onClickEdit()
        {
            this.$refs['edit-css-property-dialog'].showDialog();
        },

        onClickNamedColor(item)
        {
            this.$emit('input', item.value);
        },

        onClickColorPicker()
        {
            // Initialize color picker with current color in RGBA format
            if (this.parsed_value && this.parsed_value.type === 'rgba') {
                this.color_picker_value = {
                    r: Math.round(this.parsed_value.red * 255),
                    g: Math.round(this.parsed_value.green * 255),
                    b: Math.round(this.parsed_value.blue * 255),
                    a: this.parsed_value.alpha
                };
            }

            this.color_picker_dialog = true;
        },

        onColorPickerOk()
        {
            // Color picker value is already in RGBA format
            const rgba = this.color_picker_value;
            const color_value = `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`;

            this.$emit('input', color_value);
            this.color_picker_dialog = false;
        },



        isCustomFont(font_value) {
            return this.custom_fonts.some(cf => font_value.includes(cf.font_family_name));
        },

        fontSearchFilter(item, query_text) {
            if (!query_text) return true;
            if (item.header) return false; // Don't show headers in search results

            const query = query_text.toLowerCase();
            return item.text.toLowerCase().includes(query);
        },
    },

    computed: {
        style_color_swatch() {
            return 'background-color: '+this.css;
        },

        style_demo_font() {
            // Use smaller font size for better fit in preview area
            const font_size = this.truncated_preview_text.length > 30 ? '18px' : '22px';
            return `font-size: ${font_size}; font-family: ${this.css}`;
        },

        label() {
            return this.is_default ? 'Default Value' : 'Current Value';
        },

        organized_font_families() {
            if (this.font_families.length === 0) return [];

            // Enhance font families with custom flag
            const enhanced_fonts = this.font_families.map(font => ({
                ...font,
                is_custom: this.isCustomFont(font.value)
            }));

            // Separate built-in and custom fonts
            const built_in_fonts = enhanced_fonts.filter(f => !f.is_custom);
            const custom_fonts = enhanced_fonts.filter(f => f.is_custom);

            // Build organized list with headers - custom fonts first
            const result = [];

            if (custom_fonts.length > 0) {
                result.push({ header: 'Custom Fonts' });
                result.push(...custom_fonts);
            }

            if (built_in_fonts.length > 0) {
                result.push({ header: 'Built-in Fonts' });
                result.push(...built_in_fonts);
            }

            return result;
        },

        truncated_preview_text() {
            if (!this.preview_text) return 'Lorem ipsum';

            // Limit preview text to 50 characters for better display
            if (this.preview_text.length <= 60) {
                return this.preview_text;
            }

            return this.preview_text.substring(0, 57) + '...';
        },
    },

    watch: {
        value() {
            this.update();
        }
    },
}
</script>

<style lang="scss" scoped>
.checker
{
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
    
    background-image: url('https://files.redchirp.com/dcf69ef7-2e39-4bcd-b0ca-cd4be32eeff2.webp'); 
    background-size: cover; 
    background-position: center;
    background-repeat: no-repeat;

    z-index: 1;
}

.swatch
{
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    z-index: 2;
}

.font-demo
{
    padding: 15px;
    margin-bottom: 15px;
    margin-top: 15px;
    text-align: center;
    border: 1px solid rgba(0,0,0,0.3);
    word-wrap: break-word;
    overflow-wrap: break-word;
    max-height: 120px;
    min-height: 80px;
    overflow: hidden;
    line-height: 1.3;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    hyphens: auto;
}

.font-section-header
{
    font-weight: bold;
    color: #666;
    padding: 8px 16px;
    background-color: #f5f5f5;
    border-bottom: 1px solid #ddd;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.font-item
{
    padding: 8px 16px;
    width: 100%;
}

.font-preview
{
    font-size: 16px;
}

</style>